import React from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import WhyYouSeeingSection from '../components/landing/WhyYouSeeingSection';
import WhatSentSection from '../components/landing/WhatSentSection';
import StartingPointSection from '../components/landing/StartingPointSection';
import PricingSection from '../components/landing/PricingSection';
import WhyWeDoItSection from '../components/landing/WhyWeDoItSection';
import WhatHappensSection from '../components/landing/WhatHappensSection';
import NotReadySection from '../components/landing/NotReadySection';
import UpgradesSection from '../components/landing/UpgradesSection';
import FinalCTASection from '../components/landing/FinalCTASection';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <WhyYouSeeingSection />
        <WhatSentSection />
        <StartingPointSection />
        <PricingSection />
        <WhyWeDoItSection />
        <WhatHappensSection />
        <NotReadySection />
        <UpgradesSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
